import { InfiniteLoader } from '@ui/components/InfiniteLoader';
import { HistoryList } from '@ui/features/Trade/components/HistoryList/HistoryList';
import { Spinner } from '@ui/lib/park/ui/spinner';
import { Text } from '@ui/lib/park/ui/text';
import { useTradeHistoryInfinite } from '@ui/services/backend/hooks/useTradeHistory/useTradeHistoryInfinite';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { Center } from 'styled-system/jsx';
import type { Address } from 'viem';

export const Histories = ({
  hideFilters,
  userAddress,
}: {
  hideFilters?: boolean;
  userAddress?: Address;
}) => {
  const {
    data: history,
    isPending,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
  } = useTradeHistoryInfinite({
    initialParam: {
      page: 0,
      size: 20,
    },
    userAddress: userAddress,
  });
  const flatHistory = useMemo(() => {
    return history?.pages.flatMap((v) => v.histories);
  }, [history?.pages]);

  const emptyView = useMemo(() => {
    if (!userAddress) {
      return <Empty />;
    }
    if (isPending) {
      return (
        <Center py="6">
          <Spinner color="orange" />
        </Center>
      );
    }
    
return <Empty />;
  }, [isPending, userAddress]);

  return (
    <HistoryList
      showExecutedOnlyToggle={!hideFilters}
      history={flatHistory || []}
      emptyView={emptyView}
      infiniteLoader={
        <InfiniteLoader
          /**
           * default root is the view, this root margin means when to trigger the fetchNextPage,
           * to have better loading experience, the re-fetching can happens before user exact
           * scroll to the end, so that user do not need to wait for the data to be fetched
           */
          rootMargin="-10px"
          isPending={isFetchingNextPage}
          hasNext={hasNextPage}
          fetchNext={fetchNextPage}
        />
      }
    />
  );
};

const Empty = () => {
  return (
    <Center py="6">
      <Text textStyle="v2.ui" color="v2.text.subtle">
        No trading history yet
      </Text>
    </Center>
  );
};
